module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Regular.8fbcaa0b.ttf";